module.exports = __webpack_public_path__ + "img/DSC_9905-1.0162c27c.jpeg";